import React from "react";
import { RenderProfile } from "components/render-profile";
import client from "directus/src/client";
import FilterWrapper from "components/filter/wrapper";
import DirectusCombobox from "components/directus/combobox";

export default function UserCombobox({
  label,
  className,
  hideLabel,
  filter,
  searchPlaceholder,
  ...props
}) {

  if (hideLabel) {
    return (
      <DirectusCombobox
        client={client}
        collection="employees"
        fields={["id", "first_name", "last_name", "email", "avatar"]}
        searchKeys={["first_name", "last_name", "email"]}
        searchPlaceholder={searchPlaceholder}
        mapItem={(item) => ({
          value: item.id,
          label: <RenderProfile user={item} />,
          select: <RenderProfile user={item} />,
        })}
        filter={filter}
        className={className}
        sort={["first_name"]}
        {...props}
      />
    );
  }

  return (
    <FilterWrapper label={label} className={className}>
      <DirectusCombobox
        client={client}
        collection="employees"
        fields={["id", "first_name", "last_name", "email", "avatar"]}
        searchKeys={["first_name", "last_name", "email"]}
        searchPlaceholder={searchPlaceholder}
        mapItem={(item) => ({
          value: item.id,
          label: <RenderProfile user={item} />,
          select: <RenderProfile user={item} />,
        })}
        filter={filter}
        sort={["first_name"]}
        {...props}
      />
    </FilterWrapper>
  );
}
